var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _circle, _g2, _g3, _g4, _circle2, _g5, _circle3, _g6, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 181,
    viewBox: "0 0 195 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3047 3.43359C73.8556 1.52198 78.1297 1.52225 81.6807 3.43359L104.133 15.5703L145.797 38.0918C147.072 38.7812 148.11 39.7881 148.835 40.9844L81.6992 77.2754C78.1387 79.1999 73.8476 79.1999 70.2871 77.2754L3.15039 40.9844C3.87507 39.7879 4.91392 38.7813 6.18945 38.0918L47.8525 15.5703L70.3047 3.43359Z",
    fill: "url(#paint0_linear_2873_2574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.842 40.9805C149.586 42.2088 150 43.6364 150 45.125V126.586C150 129.524 148.389 132.226 145.804 133.623L81.7061 168.271C79.9257 169.233 77.9629 169.714 76 169.714V78.7148C77.9629 78.7148 79.9258 78.2337 81.7061 77.2715L148.842 40.9805Z",
    fill: "url(#paint1_linear_2873_2574)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2939 77.2715C72.0742 78.2337 74.0371 78.7148 76 78.7148V169.714C74.0371 169.714 72.0743 169.233 70.2939 168.271L6.19629 133.623C3.61136 132.226 2.00005 129.524 2 126.586V45.125C2.00001 43.6365 2.4133 42.2087 3.15723 40.9805L70.2939 77.2715Z",
    fill: "url(#paint2_linear_2873_2574)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8311 2.55273C73.6777 0.482093 78.3077 0.482439 82.1543 2.55273L82.1562 2.55371L104.608 14.6904L146.272 37.2119C147.452 37.8495 148.45 38.7295 149.221 39.7695L149.268 39.7529L149.697 40.4619C150.534 41.8433 151 43.45 151 45.125V126.586L150.995 126.896C150.886 130.081 149.096 132.98 146.279 134.503L82.1816 169.15C80.2529 170.193 78.1262 170.714 76 170.714C73.8738 170.714 71.7471 170.193 69.8184 169.15L5.7207 134.503C2.8128 132.931 1.00005 129.892 1 126.586V45.125L1.00586 44.8125C1.0451 43.6776 1.29806 42.5789 1.73438 41.5654L1.64648 41.5371L2.29492 40.4668C3.11026 39.1206 4.27925 37.9874 5.71387 37.2119L47.377 14.6904L69.8291 2.55371L69.8311 2.55273Z",
    stroke: "#EEF4FF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2873_2574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 40,
    width: 74,
    height: 130
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.842 40.9805C149.586 42.2088 150 43.6364 150 45.125V126.586C150 129.524 148.389 132.226 145.804 133.623L81.7061 168.271C79.9257 169.233 77.9629 169.714 76 169.714V78.7148C77.9629 78.7148 79.9258 78.2337 81.7061 77.2715L148.842 40.9805Z",
    fill: "url(#paint3_linear_2873_2574)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2873_2574)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_g_2873_2574)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 42,
    fill: "#8EB5F9"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.157 24.2324L104.133 15.5703L99.2656 12.9395L27.4667 51.8621C26.1766 52.5615 25.373 53.9111 25.373 55.3786V85.5L33 82L46.2646 97V66.6716C46.2646 65.2041 47.0682 63.8544 48.3583 63.155L120.157 24.2324Z",
    fill: "url(#paint4_linear_2873_2574)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 109.691C7 108.931 7.81547 108.449 8.48192 108.815L24.9277 117.86C26.2059 118.563 27 119.906 27 121.365V137.309C27 138.069 26.1845 138.551 25.5181 138.185L9.07232 129.14C7.79413 128.437 7 127.094 7 125.635V109.691Z",
    fill: "url(#paint5_linear_2873_2574)",
    fillOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 45,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2873_2574)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 37,
    fill: "#196BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 36,
    stroke: "url(#paint6_linear_2873_2574)",
    strokeOpacity: 0.4,
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2873_2574)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 33.5,
    stroke: "url(#paint7_linear_2873_2574)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2873_2574)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 32,
    stroke: "url(#paint8_linear_2873_2574)",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2873_2574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 99,
    width: 74,
    height: 74
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 37,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2873_2574)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_g_2873_2574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 122C159 135.255 148.255 146 135 146C121.745 146 111 135.255 111 122C111 108.745 121.745 98 135 98C148.255 98 159 108.745 159 122Z",
    fill: "url(#paint9_linear_2873_2574)",
    fillOpacity: 0.4
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 136,
    r: 33,
    stroke: "url(#paint10_linear_2873_2574)",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2873_2574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.602 123.169C164.856 120.74 168.652 120.598 171.081 122.852C173.51 125.105 173.652 128.902 171.398 131.331L150.449 153.905C148.87 155.607 146.179 155.611 144.595 153.915L128.616 136.817C126.354 134.396 126.482 130.599 128.903 128.337C131.324 126.074 135.121 126.203 137.384 128.624L146.03 137.876C146.822 138.724 148.168 138.722 148.957 137.871L162.602 123.169Z",
    fill: "#2B62C7"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.602 123.169C164.856 120.74 168.652 120.598 171.081 122.852C173.51 125.105 173.652 128.902 171.398 131.331L150.449 153.905C148.87 155.607 146.179 155.611 144.595 153.915L128.616 136.817C126.354 134.396 126.482 130.599 128.903 128.337C131.324 126.074 135.121 126.203 137.384 128.624L146.03 137.876C146.822 138.724 148.168 138.722 148.957 137.871L162.602 123.169Z",
    fill: "white",
    stroke: "url(#paint11_linear_2873_2574)",
    strokeOpacity: 0.54,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.602 123.168L148.957 137.87C148.168 138.721 146.822 138.723 146.03 137.875L137.384 128.623",
    stroke: "url(#paint12_linear_2873_2574)",
    strokeOpacity: 0.44,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.03 137.876L137.384 128.624C135.121 126.203 131.324 126.074 128.903 128.337C126.482 130.599 126.354 134.396 128.616 136.817L144.595 153.916",
    stroke: "url(#paint13_linear_2873_2574)",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_g_2873_2574",
    x: 70.2,
    y: 56.2,
    width: 159.6,
    height: 159.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "3.3333332538604736 3.3333332538604736",
    numOctaves: 3,
    seed: 6513
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 75.5999984741211,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2873_2574"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2873_2574",
    x: 109,
    y: 99,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2873_2574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2873_2574",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2873_2574",
    x: 112,
    y: 98,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2873_2574"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2873_2574",
    x: 112,
    y: 98,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2873_2574"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_g_2873_2574",
    x: 63.9,
    y: 50.9,
    width: 142.2,
    height: 142.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "5 5",
    numOctaves: 3,
    seed: 5929
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 94.19999694824219,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2873_2574"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2873_2574",
    x: 113.4,
    y: 107.65,
    width: 73.2,
    height: 61.1336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.8,
    result: "effect1_foregroundBlur_2873_2574"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2873_2574",
    x1: 75.9932,
    y1: 80.3594,
    x2: 75.9932,
    y2: 0.359375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0961538,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2873_2574",
    x1: 150,
    y1: 105.855,
    x2: 76,
    y2: 105.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CB6E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2873_2574",
    x1: 76,
    y1: 105.855,
    x2: 2,
    y2: 105.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2873_2574",
    x1: 150,
    y1: 105.855,
    x2: 76,
    y2: 105.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2873_2574",
    x1: 107.5,
    y1: 18,
    x2: 70,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475962,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664679,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841346,
    stopColor: "#80ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2873_2574",
    x1: 17,
    y1: 108,
    x2: 3,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442308,
    stopColor: "#2B77FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215FCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2873_2574",
    x1: 125.95,
    y1: 106.863,
    x2: 169.887,
    y2: 169.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E825AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2873_2574",
    x1: 130.243,
    y1: 107.054,
    x2: 172.054,
    y2: 165.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456731,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2873_2574",
    x1: 130.243,
    y1: 107.054,
    x2: 172.054,
    y2: 165.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.586538,
    stopColor: "#1157D5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1157D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2873_2574",
    x1: 135,
    y1: 98,
    x2: 135,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2873_2574",
    x1: 127.9,
    y1: 110.075,
    x2: 171.675,
    y2: 163.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100962,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2873_2574",
    x1: 145,
    y1: 124,
    x2: 167.5,
    y2: 146.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A428C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A428C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2873_2574",
    x1: 147.5,
    y1: 122.999,
    x2: 157,
    y2: 138.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49263,
    stopColor: "#005BFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2873_2574",
    x1: 145.5,
    y1: 140.5,
    x2: 135,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A428C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A428C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneBox);
export default __webpack_public_path__ + "static/media/doneBox.ff8cd15b7a05ea658600f114c27864c3.svg";
export { ForwardRef as ReactComponent };